var map = {
	"./ic_about_off.svg": 45119,
	"./ic_about_on.svg": 19771,
	"./ic_action_1.svg": 77139,
	"./ic_action_2.svg": 72335,
	"./ic_action_3.svg": 78576,
	"./ic_action_4.svg": 62111,
	"./ic_action_5.svg": 15671,
	"./ic_action_6.svg": 20928,
	"./ic_animation_off.svg": 51045,
	"./ic_animation_on.svg": 2104,
	"./ic_chat_off.svg": 3754,
	"./ic_chat_on.svg": 16225,
	"./ic_exit.svg": 65403,
	"./ic_minimize.svg": 42945,
	"./ic_more.svg": 92936,
	"./ic_navi.svg": 91685,
	"./ic_quick_chat_off.svg": 63392,
	"./ic_quick_chat_on.svg": 19214,
	"./ic_selfie_off.svg": 74456,
	"./ic_selfie_on.svg": 2115,
	"./ic_sound_off.svg": 99549,
	"./ic_sound_on.svg": 40887,
	"./ic_voice_chat_off.svg": 69490,
	"./ic_voice_chat_on.svg": 17070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26184;